/**
 * Author：brand
 * Creation Time：2019-05-15 13:44
 * Email：brandhuang@qq.com
 */
import ax from '../axios'

/**
 * 登录
 * @param params
 * @returns {*}
 */
export function loginAPI(params) {
  return ax({
    url: '/wlapi/user/loginIndex',
    method: 'POST',
    params
  })
}

/**
 * 注册
 * @returns {*}
 */
export function registerAPI(params) {
  return ax({
    url: '/wlapi/public/register',
    method: 'post',
    params
  })
}

/**
 * 获取短信验证码
 * @param params
 * @returns {*}
 */
export function getMsgCodeAPI(params) {
  return ax({
    url: '/wlapi/public/sendSmsCode',
    method: 'post',
    params
  })
}
/**
 * 获取短信验证码2
 * @param params
 * @returns {*}
 */
export function getMsgCodeCommonAPI(params) {
  return ax({
    url: '/wlapi/public/sendCode',
    method: 'post',
    params
  })
}

/**
 * 忘记密码
 * @param params
 * @returns {*}
 */
export function forgetPwdAPI(params) {
  return ax({
    url: '/wlapi/public/forget',
    method: 'post',
    params
  })
}

/**
 * 更新提示
 * @param params
 * @returns {*}
 */
export function getUpdateTipsAPI(params) {
  return ax({
    url: '/wlapi/acpconfig/getSetDate',
    method: 'GET',
    params
  })
}
